import { AboutBlock } from '@/components/about/AboutBlock';
import { AdvantageContainer } from '@/components/about/AdvantageContainer';
import { Footer } from '@/components/main/footer/Footer';
import { Grid, useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import React, { FC, ReactElement } from 'react';

interface Props {
  isMainPage?: boolean;
}

export const AboutPage: FC<Props> = (props: Props): ReactElement => {
  const { isMainPage } = props;

  const isMobile: boolean = useMediaQuery((theme: Theme): string => theme.breakpoints.down('sm'));

  return (
    <Grid container={true} direction={'column'} spacing={5} wrap={'nowrap'} sx={{ minHeight: '100%' }}>
      {!isMainPage && (
        <Grid item={true}>
          <AboutBlock />
        </Grid>
      )}
      <Grid item={true}>
        <AdvantageContainer />
      </Grid>
      {isMobile && !isMainPage && (
        <Grid item={true}>
          <Footer isMobile={true} />
        </Grid>
      )}
    </Grid>
  );
};
